import { render, staticRenderFns } from "./tableEmpty.vue?vue&type=template&id=38ea1a19&scoped=true"
import script from "./tableEmpty.vue?vue&type=script&lang=js"
export * from "./tableEmpty.vue?vue&type=script&lang=js"
import style0 from "./tableEmpty.vue?vue&type=style&index=0&id=38ea1a19&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ea1a19",
  null
  
)

export default component.exports